export const defaultStyles = {
  modal: {
    background: 'transparent',
    padding: 0,
    boxShadow: 'none',
    maxWidth: '100%',
  },
  overlay: {
    background: 'rgba(0, 0, 0, 0.75)',
    zIndex: '1005',
  },
  closeButton: {
    zIndex: 201,
    cursor: 'pointer',
    top: '-60px',
    rigth: '290px',
  },
  closeIcon: {
    width: '48px',
    height: '48px',
    fill: 'white',
  },
};

export const mobileStyles = {
  modal: {
    background: 'transparent',
    padding: 0,
    boxShadow: 'none',
    maxWidth: '100%',
    position: 'static',
  },
  overlay: {
    background: 'rgba(0, 0, 0, 0.75)',
    zIndex: '1005',
  },
  closeButton: {
    zIndex: 201,
    cursor: 'pointer',
    top: '16px',
    right: '16px',
    position: 'absolute',
  },
  closeIcon: {
    width: '24px',
    height: '24px',
    fill: 'white',
  },
};

export const mobileVideoModalStyles = {
  overlay: {
    padding: 0,
    background: '#000',
  },
  modal: {
    height: '100%',
  },
  closeButton: {
    top: 'revert-layer',
  },
};

export const navigation = {
  nextEl: '.swiper-button-next',
  prevEl: '.swiper-button-prev',
  // задаем свой класс, чтобы при загрузки страницы не пропадали стрелки
  lockClass: 'swiper-lock',
};
